import DropdownSelect from "@components/WebsiteRevamp/Dropdown/DropdownSelect"
import Typography, {Size} from "@components/WebsiteRevamp/Typography/Typography"
import {translate} from "@helpers/translate"
import Image from "next/image"
import {useRouter} from "next/router"
import React from "react"

import styles from "./LoginSelect.module.scss"

type Props = {
	isShown: number
	setIsShown: (id: number) => void
	activeContext?: "desktop" | "mobile"
}

const LoginSelect: React.FC<Props> = ({
	isShown,
	setIsShown,
	activeContext = "desktop",
}) => {
	const router = useRouter()

	const options = [
		{
			key: "studio",
			render: (
				<a
					href={"https://dreambroker.com/studio/login"}
					target={"_blank"}
					className={`${styles.optionBox} ${styles.studio}`}
					rel={"noreferrer"}
				>
					{/* <div>
						Studio */}
					<Image
						className={styles.LogoImage}
						src={"/Group-2586.svg"}
						width={50}
						height={18}
						alt={"Drem Broker Studio Logo login"}
					/>
					{/* </div> */}
					{/* <SignInIcon className={styles.svgIcon} /> */}
				</a>
			),
		},
		{
			key: "one",
			render: (
				<a
					href={"https://app.one.dreambroker.com/"}
					target={"_blank"}
					className={`${styles.optionBox} ${styles.one}`}
					rel={"noreferrer"}
				>
					<Image
						className={styles.LogoImage}
						src={"/Product-Logo-7.svg"}
						width={50}
						height={18}
						alt={"Drem Broker #One Logo login"}
					/>
					{/* <SignInIcon className={styles.svgIcon} /> */}
				</a>
			),
		},
	]

	return (
		<DropdownSelect
			id={-2}
			isShown={isShown}
			setIsShown={setIsShown}
			options={options}
			buttonContent={
				<Typography
					content={translate("Sign in", router.locale)}
					fontWeight={700}
					size={Size.XS}
					noPadding
				/>
			}
			activeContext={activeContext}
			menuClassName={styles.selectMenu}
			optionClassName={styles.option}
			selectedOptionClassName={styles.signInButton}
		/>
	)
}

export default LoginSelect
